import React, { useEffect, useState, useRef } from 'react'
import styles from './upload-modal.scss'
import UploadMain from 'assets/icons/upload-main.png'
import CSVFileUpload from '../../../../Components/CSVFileUpload/CSVFileUpload'
import { connect } from 'react-redux'
import { changeAddGuestsList } from 'src/actions/event'
import PropTypes from 'prop-types'
import Tour from 'src/components/common/Tour/Tour'
import { TOUR_STEPS, getTourState, setTourFlag } from 'src/services/tour_storage_utils'

const UploadModal = ({
  addGuestsList,
  onChangeAddGuestsList
}) => {
  const [isOpenCSVUploadModal, setIsOpenCSVUploadModal] = useState(false)
  const [showTour, setShowTour] = useState(false)
  const stepConfig = TOUR_STEPS.find(step => step.key === 'addGuests')
  const tourState = getTourState()
  const showAddGuestsTour = !tourState.isAddGuestsTourOpened
  const isSkipped = tourState.isSkipped

  const uploadFileRef = useRef()

  useEffect(() => {
    if (uploadFileRef.current && !showTour) {
      setShowTour(true)
    }
  }, [uploadFileRef.current])
  const handleGetGuestsFromCSV = (guests) => {
    onChangeAddGuestsList([...guests, ...addGuestsList])
  }

  const handleTourClose = () => {
    setTourFlag('isAddGuestsTourOpened', true)
    setShowTour(false)
  }

  return (
    <>
      <div className={styles['upload-modal-container']} >
        <div
          className={styles['open-button-inner']}
          onClick={() => setIsOpenCSVUploadModal(true)}
          ref={uploadFileRef}
        >
          <img src={UploadMain} alt="" width="20" />
          <span>upload file</span>
        </div>

        <CSVFileUpload
          visible={isOpenCSVUploadModal}
          onGetGuestsFromCSV={handleGetGuestsFromCSV}
          onClose={() => setIsOpenCSVUploadModal(false)}
        />
      </div>
      <Tour
        open={showTour && showAddGuestsTour && !isSkipped}
        steps={[{ ...stepConfig, target: uploadFileRef }]}
        highlightPadding={[8, 12]}
        mask
        arrow
        showSkipButton={false}
        onFinish={handleTourClose}
        onClose={handleTourClose}
      />
    </>
  )
}

UploadModal.propTypes = {
  addGuestsList: PropTypes.array,
  onChangeAddGuestsList: PropTypes.func
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeAddGuestsList: params => dispatch(changeAddGuestsList(params))
  }
}

function mapStateToProps(state) {
  return {
    addGuestsList: state.frontend.addGuestsList
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadModal)
